var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { pxToRem } from '../utils/utils';
import { breakpoints } from './breakpoints';
var baseFontFamily = [
    '-apple-system',
    'blinkmacsystemfont',
    'Segoe UI',
    'roboto',
    'helvetica',
    'arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol'
];
export var fontStyles = {
    baseFontFamily: baseFontFamily,
    baseFontSize: '20px',
    fontFamilies: {
        'china-simplified': ['sans-serif'],
        'china-traditional': ['sans-serif'],
        korea: ['sans-serif'],
        japan: ['sans-serif'],
        'eastern-europe': baseFontFamily,
        roman: __spreadArray(['FinnairSans'], baseFontFamily, true),
    },
    fontWeights: {
        light: 200,
        regular: 400,
        medium: 600,
        bold: 700,
        black: 900,
        /**
         * Alias for black as "black" is a keyword in SCSS and cannot be used in some cases
         */
        _strongBold: 900
    },
    fontSizes: (_a = {},
        _a[breakpoints.mobile] = {
            'heading-1': {
                isBold: true,
                fontSize: pxToRem('32px'),
                lineHeight: pxToRem('40px')
            },
            'heading-2': {
                isBold: true,
                fontSize: pxToRem('24px'),
                lineHeight: pxToRem('32px')
            },
            'heading-3': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'heading-4': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'heading-5': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'body-1': {
                isBold: false,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('24px')
            },
            'body-2': {
                isBold: false,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px')
            },
            'caption-1': {
                isBold: false,
                fontSize: pxToRem('12px'),
                lineHeight: pxToRem('16px')
            },
        },
        _a[breakpoints.tablet] = {
            'heading-1': {
                isBold: true,
                fontSize: pxToRem('32px'),
                lineHeight: pxToRem('40px')
            },
            'heading-2': {
                isBold: true,
                fontSize: pxToRem('24px'),
                lineHeight: pxToRem('32px')
            },
            'heading-3': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'heading-4': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'heading-5': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'body-1': {
                isBold: false,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('24px')
            },
            'body-2': {
                isBold: false,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px')
            },
            'caption-1': {
                isBold: false,
                fontSize: pxToRem('12px'),
                lineHeight: pxToRem('16px')
            },
        },
        _a[breakpoints.laptop] = {
            'heading-1': {
                isBold: true,
                fontSize: pxToRem('48px'),
                lineHeight: pxToRem('56px')
            },
            'heading-2': {
                isBold: true,
                fontSize: pxToRem('40px'),
                lineHeight: pxToRem('48px')
            },
            'heading-3': {
                isBold: true,
                fontSize: pxToRem('32px'),
                lineHeight: pxToRem('40px')
            },
            'heading-4': {
                isBold: true,
                fontSize: pxToRem('24px'),
                lineHeight: pxToRem('32px')
            },
            'heading-5': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'body-1': {
                isBold: false,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('24px')
            },
            'body-2': {
                isBold: false,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px')
            },
            'caption-1': {
                isBold: false,
                fontSize: pxToRem('12px'),
                lineHeight: pxToRem('16px')
            },
        },
        _a[breakpoints.desktop] = {
            'heading-1': {
                isBold: true,
                fontSize: pxToRem('48px'),
                lineHeight: pxToRem('56px')
            },
            'heading-2': {
                isBold: true,
                fontSize: pxToRem('40px'),
                lineHeight: pxToRem('48px')
            },
            'heading-3': {
                isBold: true,
                fontSize: pxToRem('32px'),
                lineHeight: pxToRem('40px')
            },
            'heading-4': {
                isBold: true,
                fontSize: pxToRem('24px'),
                lineHeight: pxToRem('32px')
            },
            'heading-5': {
                isBold: true,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('28px')
            },
            'body-1': {
                isBold: false,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('24px')
            },
            'body-2': {
                isBold: false,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px')
            },
            'caption-1': {
                isBold: false,
                fontSize: pxToRem('12px'),
                lineHeight: pxToRem('16px')
            },
        },
        _a),
};
var fontWeightNames = {
    regular: 400,
    bold: 700,
    medium: 500,
};
var atlasFinnairHeadline = __spreadArray(['Finnair Headline'], baseFontFamily, true);
var atlasFinnairText = __spreadArray(['Finnair Text'], baseFontFamily, true);
export var atlasFontStyles = {
    baseFontFamily: baseFontFamily,
    baseFontSize: '20px',
    fontFamilies: {
        'china-simplified': ['sans-serif'],
        'china-traditional': ['sans-serif'],
        korea: ['sans-serif'],
        japan: ['sans-serif'],
        'eastern-europe': baseFontFamily,
        roman: atlasFinnairText,
        romanHeadline: atlasFinnairHeadline,
    },
    fontWeights: {
        regular: fontWeightNames.regular,
        medium: fontWeightNames.medium,
        bold: fontWeightNames.bold,
    },
    fontSizes: (_b = {},
        _b[breakpoints.mobile] = {
            'display': {
                fontFamily: atlasFinnairHeadline,
                fontSize: pxToRem('40px'),
                lineHeight: pxToRem('44px'),
                fontWeight: fontWeightNames.medium,
            },
            'headline': {
                fontFamily: atlasFinnairHeadline,
                fontSize: pxToRem('32px'),
                lineHeight: pxToRem('38px'),
                fontWeight: fontWeightNames.regular,
            },
            'title': {
                fontFamily: atlasFinnairHeadline,
                fontSize: pxToRem('24px'),
                lineHeight: pxToRem('28px'),
                fontWeight: fontWeightNames.regular,
            },
            'emphasis': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('20px'),
                lineHeight: pxToRem('24px'),
                fontWeight: fontWeightNames.bold,
            },
            'body-m': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('22px'),
                fontWeight: fontWeightNames.regular,
            },
            'body-m-m': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('22px'),
                fontWeight: fontWeightNames.medium,
            },
            'body-m-b': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('16px'),
                lineHeight: pxToRem('22px'),
                fontWeight: fontWeightNames.bold,
            },
            'body-s': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px'),
                fontWeight: fontWeightNames.regular,
            },
            'body-s-b': {
                fontFamily: atlasFinnairText,
                fontSize: pxToRem('14px'),
                lineHeight: pxToRem('20px'),
                fontWeight: fontWeightNames.bold,
            },
        },
        _b)
};
